module.exports = __webpack_public_path__ + "media/images/background_offer-5e011af9.jpg";